import {
  CateringServiceRow,
  CateringServiceRowValues
} from "../Domain/Types/FacilityService-row.types";

/**
 * takes row data and assembles a partial catering item object
 */
export function mapUpdatedRowToPartialCateringItem(
  values: CateringServiceRowValues,
  rowOriginal: CateringServiceRow
): Partial<CateringServiceRow> {
  return {
    id: values["id"] ?? rowOriginal.id,
    name: values.name,
    pricePerUnit: values.pricePerUnit,
    description: values["description"],
    location: {
      id: values["location.id"],
      name: values["location.name"]
    },
    servicePermissions: values.servicePermissions,
    picturePath: values.picturePath
  };
}
